export default "https://cdn-static.gokick.com/assets/ed6531e95fd3f911890bedfaed34e81f4e5a2128/images/citrus-zen.2d0942f5031f42be498b3d61071e3237.png";